import { Typography } from "@mui/material";
import { CoreChip, VerityColorLogo } from "../../core";
import ThemeWrapper from "../../theme";
import i18nPackage from "../../i18n/i18n";

export default function VerityBadge() {
	return (
		<ThemeWrapper scoped={false}>
			<CoreChip
				chipColor="#E5FFFF"
				sx={{
					height: "28px",
					borderRadius: "6px",

					"& .MuiChip-label": {
						display: "flex",
						flexDirection: "row",
						gap: "4px",
						alignItems: "center",
						justifyContent: "center",
						padding: "2px 4px",
					},

					"& .MuiTypography-root": {
						color: "#004e4e",
						fontSize: "14px",
						fontWeight: 500,
						lineHeight: 1.6,
						margin: 0,
					},
				}}
				variant="rectangular"
			>
				<div style={{ display: "inline-flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}>
					<VerityColorLogo height={18} width={18} />
					<Typography>{i18nPackage.t("interceptStrategy.badge")}</Typography>
				</div>
			</CoreChip>
		</ThemeWrapper>
	);
}
